import { H2, HorizontalSelector } from 'src/components/_commons';
import { months } from '@monorepo/helpers';
import { useState } from 'react';

export const AdminsMonthlyReports = () => {
    const [selectedDate, setSelectedDate] = useState(new Date());

    return (
        <>
        <H2 title={'INFORMES DE PREDICACIÓN'} />

        <HorizontalSelector
            label={`${months[selectedDate.getMonth()]} ${selectedDate.getFullYear()}`}
            setNext={() => {
                const nextMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, 1);
                setSelectedDate(nextMonth);
            }}
            setPrevious={() => {
                const prevMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth() - 1, 1);
                setSelectedDate(prevMonth);
            }}
        />

        <div>
            <h5>En desarrollo</h5>
        </div>
        </>
    )
}
